
import styled from 'styled-components';
export const DragContainer = styled.div`
background-color: ${props => (props.isDragging ? '#e7f9ff' : props.backgroundColor)}

`;